import Router from './config/Router/Router';
import React from 'react';

const App = () => {
  return <Router />;
};

export default App;
